import React from 'react';

// A simplified version of TopAppCardM specifically for the Hits page
const HitsCard = ({ gamedata, details, isHighlighted }) => {
  const formatNumber = num => {
    if (num >= 1e6) {
      return (num / 1e6).toFixed(1) + " M"; // Convert to millions
    } else if (num >= 1e3) {
      return (num / 1e3).toFixed(1) + " K"; // Convert to thousands
    }
    const n = Math.round(num);
    return n; // Return as is if less than 1000
  };

  const formatPrice = (price) => {
    if (!price || price.amount === 0) return "Free";
    return `$${price.amount || "39.99"}`;
  };

  return (
    <div className={`hits-card ${isHighlighted ? 'highlighted' : ''}`}>
      <div className="hits-card-content">
        <div>
          <h2 className="hits-card-title">
            {gamedata?.name || (isHighlighted ? "ULTRA HEIGHT 2: HD ALTITUDE CHALLENGES (Climb & Fly)" : "VRChat")}
          </h2>
          <p className="hits-card-subtitle">
            {gamedata?.publisher || (isHighlighted ? "Devolver Digital • Adventure" : "VRChat Inc. • Games")}
          </p>
          
          <div className="hits-card-details">
            <div className="hits-card-detail-group">
              <p className="hits-card-detail-label">Price</p>
              <p className="hits-card-detail-value">
                {formatPrice(gamedata?.price) || (isHighlighted ? "$10" : "Free")}
              </p>
            </div>
            
            <div className="hits-card-detail-group">
              <p className="hits-card-detail-label">Revenue</p>
              <p className="hits-card-detail-value">
                $ {formatNumber(gamedata?.revenue) || (isHighlighted ? "1.6 M" : "4.4 M")}
              </p>
            </div>
          </div>
        </div>
        
        <div className="hits-card-image">
          <img
            src={gamedata?.image_url || "https://via.placeholder.com/120x68"}
            alt="App Icon"
          />
        </div>
      </div>
    </div>
  );
};

export default HitsCard; 